import { render, staticRenderFns } from "./targeting.vue?vue&type=template&id=2b1022e6"
import script from "./targeting.vue?vue&type=script&lang=js"
export * from "./targeting.vue?vue&type=script&lang=js"
import style0 from "./targeting.vue?vue&type=style&index=0&id=2b1022e6&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports